import { render, staticRenderFns } from "./QuickTipsSharedIds.vue?vue&type=template&id=3f5ba831&scoped=true&"
import script from "./QuickTipsSharedIds.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSharedIds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ba831",
  null
  
)

export default component.exports